import Vue from 'vue';

export default new Vue({
    data: function () {
        return {
            grid_view: false,
            mobile_view: false,
            open_filters: true
        }
    },
    methods: {
        toggleFilter: function () {
            this.open_filters = !this.open_filters
        }
    }
 })
